import NewUserGraph from './NewUsersGraph';

export default NewUserGraph;
